export class Address {
  city?: string;
  state?: string;
  country?: string;
  line1?: string;
  line2?: string;
}
